import React from "react";
import { Facebook, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-forest-950 text-ivory">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-9 w-9 bg-brass flex items-center justify-center">
              <span className="font-serif text-forest-950 text-xl leading-none">i</span>
            </div>
            <span className="font-serif text-2xl tracking-tight text-ivory">
              Incent<span className="text-brass">Tax</span>
            </span>
          </div>
          <p className="text-ivory/70 leading-relaxed max-w-md">
            Engineering-based cost segregation and R&D tax credit studies for
            real estate investors, business owners, private equity firms, and
            the CPAs who serve them.
          </p>

          <div className="mt-8 flex items-center gap-3" data-testid="footer-social">
            <a
              href="https://www.facebook.com/profile.php?id=61590600939092"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="IncentTax on Facebook"
              data-testid="footer-facebook"
              className="h-10 w-10 inline-flex items-center justify-center border border-ivory/20 text-ivory/80 hover:text-forest-950 hover:bg-brass hover:border-brass transition-colors"
            >
              <Facebook size={18} strokeWidth={1.75} />
            </a>
            <a
              href="https://www.instagram.com/incenttax/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="IncentTax on Instagram"
              data-testid="footer-instagram"
              className="h-10 w-10 inline-flex items-center justify-center border border-ivory/20 text-ivory/80 hover:text-forest-950 hover:bg-brass hover:border-brass transition-colors"
            >
              <Instagram size={18} strokeWidth={1.75} />
            </a>
            <a
              href="https://x.com/IncentTax"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="IncentTax on X"
              data-testid="footer-x"
              className="h-10 w-10 inline-flex items-center justify-center border border-ivory/20 text-ivory/80 hover:text-forest-950 hover:bg-brass hover:border-brass transition-colors"
            >
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                <path d="M18.244 2H21.5l-7.49 8.56L22.5 22h-6.79l-5.32-6.95L4.3 22H1.04l8.01-9.15L1.5 2h6.96l4.81 6.36L18.244 2Zm-2.38 18h1.88L7.27 4H5.28l10.585 16Z"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-brass uppercase tracking-[0.22em] text-xs mb-4">
            Services
          </p>
          <ul className="space-y-2 text-ivory/80">
            <li><a href="/services/cost-segregation" className="hover:text-brass">Cost Segregation</a></li>
            <li><a href="/services/rd-tax-credit" className="hover:text-brass">R&D Tax Credit</a></li>
            <li><a href="/for-tax-professionals" className="hover:text-brass">For CPAs</a></li>
            <li><a href="/about" className="hover:text-brass">About</a></li>
            <li><a href="/knowledge" className="hover:text-brass">Knowledge Center</a></li>
            <li><a href="/#estimator" className="hover:text-brass">Free Estimator</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-brass uppercase tracking-[0.22em] text-xs mb-4">
            Get in touch
          </p>
          <ul className="space-y-2 text-ivory/80">
            <li><a href="mailto:info@incenttax.com" className="hover:text-brass">info@incenttax.com</a></li>
            <li><a href="tel:+18888541637" className="hover:text-brass"><span data-nosnippet>1-888-854-1637</span></a></li>
            <li>24 West Camelback Road #467<br/>Phoenix, AZ 85013</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-ivory/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-ivory/50 text-xs">
          <div>© {new Date().getFullYear()} IncentTax. All rights reserved.</div>
          <div className="text-center sm:text-right max-w-xl">
            IncentTax is a tax engineering firm; we deliver studies and reports.
            We do not provide legal, accounting, or tax advice. Engage your CPA
            and counsel before filing.
          </div>
        </div>
      </div>
    </footer>
  );
}
